import React, { useState, useEffect } from 'react';

const MenuFilter = (props) => {
    const [keyword, setKeyword] = useState("");
    const [keywords, setKeywords] = useState([]);
    const [isExpanded, setIsExpanded] = useState(false);
    const [selectedFilterProduct, setSelectedFilterProduct] = useState("");
    const [filteredMenuList, setFilteredMenuList] = useState({});

    const handleRadioChange = (e) => {
        const { value } = e.target;
        setSelectedFilterProduct(value); // 상태 변경
    };

    useEffect(() => {
        setKeywords([]);
        if (props.menuData.children) {
            let searchData = props.menuData.children;

            if (selectedFilterProduct) {
                searchData = filterMenuByProduct(searchData, selectedFilterProduct);
            }

            if (searchData.length !== 0) {
                setFilteredMenuList({
                    ...props.menuData,
                    children: searchData
                });
            } else {
                setFilteredMenuList({});
            }
        } else {
            setFilteredMenuList(props.menuData);
        }
    }, [selectedFilterProduct]);

    useEffect(() => {
        props.setFilteredMenu(filteredMenuList);
    }, [filteredMenuList]);

    useEffect(() => {
        setKeywords([]);
        setFilteredMenuList({});
        setSelectedFilterProduct("");
    }, [props.categoryList]);

    const handleKeyUp = (e) => {
        if (e.key === "Enter" && keyword.trim()) {
            handleFilter();
        }
    };

    const handleDelete = (deleteKeyword) => {
        const newKeywords = keywords.filter((k) => k !== deleteKeyword);
        const filteredChildren = filterModules(filteredMenuList.children || props.menuData.children, newKeywords);
        setKeywords(newKeywords);
        if (newKeywords.length === 0) {
            props.setFilteredMenu(filteredMenuList);
        } else {
            if (filteredChildren.length !== 0) {
                props.setFilteredMenu({
                    ...filteredMenuList,
                    children: filteredChildren
                });
            } else {
                props.setFilteredMenu(null);
            }
        }
    };

    const handleFilter = () => {
        const trimmedKeyword = keyword.trim();
        if (!trimmedKeyword) return;
        if (!keywords.includes(trimmedKeyword)) {
            const newKeywords = [...keywords, trimmedKeyword];
            const filteredChildren = filterModules(filteredMenuList.children || props.menuData.children, newKeywords);
            setKeywords(newKeywords);
            if (newKeywords.length === 0) {
                props.setFilteredMenu(filteredMenuList);
            } else {
                if (filteredChildren.length !== 0) {
                    props.setFilteredMenu({
                        ...filteredMenuList,
                        children: filteredChildren
                    });
                } else {
                    props.setFilteredMenu(null);
                }
            }
        }
        setKeyword("");
    };

    const filterModules = (children, keywords) => {
        let result = [];

        children.forEach((child) => {
            const isModuleMatch = keywords.some((keyword) =>
                child.module.toLowerCase().includes(keyword.toLowerCase())
            );
            let isDocumentsMatch = false;
            if (child.documents && Array.isArray(child.documents) && child.documents.length > 0) {
                isDocumentsMatch = child.documents.some((document) =>
                    document.tag && Array.isArray(document.tag) && document.tag.some((tag) =>
                        keywords.every((keyword) =>
                            tag.toLowerCase().includes(keyword.toLowerCase())
                        )
                    )
                );
            }
            const filteredChildren = child.children ? filterModules(child.children, keywords) : [];

            if (isModuleMatch || isDocumentsMatch) {
                //const newChild = {
                //    module: child.module,
                //    manualId: child.manualId,
                //    documents: child.documents
                //};
                //if (filteredChildren.length > 0) {
                //    newChild.children = filteredChildren;
                //}
                result.push(child);
            } else if (filteredChildren.length > 0) {
                filteredChildren.forEach((filteredChild) => {
                    result.push(filteredChild);
                });
            }
        });
        return result;
    };

    const handleFilterToggle = () => {
        setIsExpanded(!isExpanded);
    };

    const ProductFilter = () => {
        if (props.categoryList?.length === 0) {
            return null; // cateList가 비어있으면 아무것도 렌더링하지 않음
        }
        return (
            <div className="product-filter">
                <a className="product-filter-top" onClick={(e) => handleFilterToggle(e)}>
                    <p className="product-filter-title">제품군</p>
                    <div className={`btn-expand ${isExpanded ? "" : "collapse"}`}>
                        <i className="icoKdc16 expand"></i>
                    </div>
                </a>
                <ul className="product-filter-list" style={{ display: isExpanded ? "block" : "none" }}>
                    <li key={0} className="product-filter-list-each">
                        <input
                            type="radio"
                            id={"all"}
                            name="products"
                            value={""}
                            onChange={(e) => handleRadioChange(e)}
                            checked={selectedFilterProduct === ""}
                        />
                        <label htmlFor={"all"}>
                            전체
                        </label>
                    </li>
                    {props.categoryList?.map((item, index) => (
                        <li key={index} className="product-filter-list-each">
                            <input
                                type="radio"
                                id={item.type}
                                name="products"
                                value={item.type}
                                onChange={(e) => handleRadioChange(e)}
                                checked={selectedFilterProduct === item.type}
                            />
                            <label htmlFor={item.type}>
                                {`K-System ${item.type.charAt(0).toUpperCase() + item.type.slice(1)}`}
                            </label>
                        </li>
                    ))}
                </ul>
            </div>
        );
    };

    const filterMenuByProduct = (menu, product) => {
        return menu.map((item) => {
            const filteredDocuments = item.documents?.filter(
                (doc) => (doc.product === product || doc.product === undefined || doc.product === '')
            );

            const filteredChildren = item.children
                ? filterMenuByProduct(item.children, product)
                : null;

            if (
                (filteredDocuments && filteredDocuments.length > 0) ||
                (filteredChildren && filteredChildren.length > 0)
            ) {
                return {
                    ...item,
                    documents: filteredDocuments,
                    ...(filteredChildren && { children: filteredChildren }),
                };
            }
            return null;
        }).filter(Boolean);
    };

    let placeholder = props.placeholder != undefined ? props.placeholder : "제목 필터"

    return (
        <div className='filters'>
            {ProductFilter()}
            <div className="search-filter">
                <i className='icoKdc24 magnifier-b'></i>
                <input type="text" placeholder={placeholder} value={keyword} onChange={(e) => setKeyword(e.target.value)} onKeyUp={e => handleKeyUp(e)} />
            </div>
            <div className="keywords">
                {keywords.map((k, index) => (
                    <div className="keyword-each" key={index}>
                        <p>{k}</p>
                        <div className="btn-delete" onClick={() => handleDelete(k)}>
                            <i className="icoKdc12 delete"></i>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
export default MenuFilter;